import { SET_ALL_PERMISSIONS, SET_SESSION } from "./types";
import config from "../../config/config";
import axios from "axios";
import {setPackagePermissionData} from '../utills';
const apiDomain = config.apiDomains[0];

export const setAllPermissions = payload => async dispatch => {
	// let allPermission = axios.get(`${apiDomain}/marketplace/supplier/getAllPermission.service`);
	// let deliveryData = axios.get(`${apiDomain}/marketplace/gis/getDeliveryTimeBand.service`);
	// let deliveryApi = axios.get(location.origin + '/marketplace/gis/listAllDeliveryProfile.service');
	// let outletApi = axios.get(location.origin + '/marketplace/outlet/getOutletByStaffMemberId.service?&isPermissionBased=false');
	if(payload.supId && payload.token){
		let taxApi = axios.get(location.origin + `/marketplace/static/php/web/b2bWebsite.php?action=getAllTaxRates&supplierId=${payload.supId}&token=${payload.token}`);
		let taxZonesApi=null
		if(!payload.viaOmni){
			taxZonesApi = axios.get(location.origin + `/static/php/web/b2bWebsite.php?action=getAllTaxZones&supplierId=${payload.supId}&token=${payload.token}`);
		} else{
			taxZonesApi = axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=getAllTaxZones&supplierId=${payload.supId}&token=${payload.token}`);
		}
		const apis=[ taxApi, taxZonesApi]
		if(payload.viaOmni){
			apis.push(
				axios.get(`${apiDomain}/marketplace/supplier/getAllPermission.service`), 
				axios.get(apiDomain + '/marketplace/outlet/getOutletByStaffMemberId.service?&isPermissionBased=false'),
				axios.get(location.origin + `/marketplace/tax/ajax/service/getAllTax.service`)
			);
		}
		Promise.allSettled(apis)
			.then(response => {
				let data = {};
				if(response[0].status=="fulfilled") {
					data.taxData = response[0].value.data;
				}
				if(response[1].status=="fulfilled") {
					data.taxZones = response[1].value.data["taxZones"];
				}
				if(payload.viaOmni && response[2].status=="fulfilled") {
					data = {
						...data,
						...response[2].value.data
					};
					data.packagePermissionData=response[2].value.data
				}
				if(payload.viaOmni && response[3].status=="fulfilled") {
					data.outletData = response[3].value?.data && response[3].value.data["outlets"];
				}
				if(payload.viaOmni && response[4].status=="fulfilled") {
					data.purchaseTaxData = response[4].value?.data;
				}
				// setPackagePermissionData(data.packageId).then((res) => {
				// 	data.packagePermissionData = res.data.data;
				dispatch({
					type: SET_ALL_PERMISSIONS,
					payload: data
				});
				// });
				// dispatch({
				// 	type: SET_SESSION,
				// 	payload: {
				// 		countryCode: data.countryCode
				// 	}
				// })
			});
	}
};